<template>
  <header :class="$style['header-container']">
    <div :class="$style.top">
      <div :class="$style['other-link']">
        <ul>
          <li @click="toPath('https://www.jufair.com/manager/ticket-my/')">
            {{ lang_t('menu.top.ticket') }}
          </li>
          <!-- <li @click="toPath('/manager/periodical-my/')">展商名录</li> -->
          <li @click="toPath('https://www.jufair.com/manager/fair-my/')">
            {{ lang_t('menu.top.fair') }}
          </li>
          <li @click="toPath('https://www.jufair.com/manager/industry-my/')">
            {{ lang_t('menu.top.industry') }}
          </li>
          <!-- <li @click="toPath('/exhibition/top100.html')">
            {{ lang_t('menu.top.leaderboard') }}
          </li> -->
          <li @click="toPath('https://www.jufair.com/sitemap/')">
            {{ lang_t('menu.top.sitemap') }}
          </li>
          <li
            v-if="!isLogin"
            :class="$style.red"
            @click="handleLogin">
            {{ lang_t('menu.top.signup') }}
          </li>
          <li
            v-if="isLogin"
            @click="toPath('https://www.jufair.com/manager/')">
            {{ lang_t('menu.top.order') }}
          </li>
          <li
            v-if="isLogin"
            :class="$style.logout"
            @click="handleLogout">
            {{ lang_t('menu.top.quit') }}
          </li>
        </ul>
        <!-- <div :class="$style['header-lang']" @click="handleSetLang">
          <i class="el-icon-basketball" />
          中｜EN
        </div> -->
      </div>
    </div>
    <menu :class="$style.menu">
      <a
        :title="lang_t('common.site_title')"
        href="/">
        <div class="el-icon-logo" />
      </a>
      <div :class="$style.list">
        <ul>
          <li
            v-for="item in menu"
            v-show="!item.hidden"
            :key="item.title"
            :class="{ [$style.active]: item.path === routeRoute.path }">
            <a
              :href="item.path"
              :title="item.title"
              target="_blank">
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>
      <div :class="$style['search-container']">
        <el-input
          v-model="keyword"
          :class="keywordError ? `${$style['search-input']} ${$style['search-input__error']}` : $style['search-input']"
          :placeholder="keywordPlaceholder"
          @input="handleKeywordInput"
          @keyup.enter="handleSearch" />
        <el-button
          :aria-label="lang_t('common.search')"
          :class="$style['search-btn']"
          :icon="Search"
          @click="handleSearch" />
      </div>
    </menu>
  </header>
</template>

<script setup lang="ts">
  import { inject } from 'vue'
  import { Search } from '@element-plus/icons-vue'
  import _ from 'lodash'
  import { ResponseCode } from '~/utils/constant'
  import type Login from '~/components/Login/index.vue'
  import { fetchAuthLogout } from '~~/server/api/auth'

  // 组合式API hooks
  const globalStore = useGlobalStore()
  const route = useRoute()
  const { t: $t, locale } = useI18n()
  const { public: env } = useRuntimeConfig()
  const origin = useSSROrigin()

  // Cookie管理
  const phoneCookie = useCookie<string | undefined>('phoneNumber', {
    domain: 'jufair.com'
  })
  const tokenCookie = useCookie<string | undefined>('access_token', {
    domain: 'jufair.com'
  })

  // 依赖注入
  const loginModal = inject<Ref<InstanceType<typeof Login>> | null>('loginModal', null)

  // 响应式数据
  const keyword = ref('')
  const keywordError = ref(false)
  const keywordPlaceholder = ref($t('menu.keywordPlaceholder1'))

  // 计算属性
  let isLogin = ref(false)
  if (import.meta.client) {
    isLogin = computed(() => globalStore.isLogin)
  }

  // 菜单配置
  const menu = ref([
    {
      label: $t('menu.home'),
      title: $t('common.site_title'),
      path: origin.value,
      activePath: '/',
      extra: true
    },
    {
      label: $t('menu.domestic'),
      title: $t('menu.domestic'),
      path: `${origin.value}/exhibition-0-0-1-0-0-0-1/`,
      activePath: 'exhibition-(\\d+)-(\\d+)-1'
    },
    {
      label: $t('menu.international'),
      title: $t('menu.international'),
      path: `${origin.value}/exhibition-0-0-0-0-0-0-1/`,
      activePath: /^\/exhibition((-\d+){2}(-[0,2-9]+)(-\d+){4})?\/?/
    },
    {
      label: $t('menu.exhibitionInfo'),
      title: $t('menu.exhibitionInfo'),
      path: `${origin.value}/information/`,
      activePath: '/information'
    },
    {
      label: $t('menu.conventionCenter'),
      title: $t('menu.conventionCenter'),
      path: `${origin.value}/pavilion/`,
      activePath: /^\/pavilion((-\d+){2}(-[0,2-9]+)(-\d+){4})?\/?/
    },
    {
      label: $t('menu.cooperate'),
      title: $t('menu.cooperate'),
      path: `${origin.value}/cooperation.html`,
      activePath: '/cooperation.html'
    },
    {
      label: $t('menu.visa'),
      title: $t('menu.visa'),
      path: `${env.config.VISA}/visa-0-0-0-0-1/`,
      activePath: 'visa-(\\d+)-(\\d+)-(\\d+)-(\\d+)-1'
    }
    // {
    //   label: '参展企业',
    //   title: '参展企业',
    //   path: `${origin.value}/company/`,
    //   activePath: '/company',
    //   hidden: true
    // }
  ])

  // 设置语言
  const setLang = (lang: string) => {
    locale.value = lang
  }

  // 打开新窗口
  const toPath = (url: string) => {
    window.open(url, '_blank')
  }

  // 处理登录
  const handleLogin = () => {
    loginModal?.value?.open()
  }

  // 清除所有Cookie
  const clearAllCookies = () => {
    const cookies = document.cookie.split(';')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i]
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim()
      // 删除主域下的 cookie（尝试多种组合）
      ;[
        { path: '/', domain: 'jufair.com' },
        { path: '/', domain: '.jufair.com' },
        { path: '/', domain: window.location.hostname },
        { path: '/;', domain: '' } // fallback
      ].forEach(({ path, domain }) => {
        const domainStr = domain ? `; domain=${domain}` : ''
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}${domainStr}`
      })
    }
  }

  // 处理登出
  const handleLogout = async () => {
    try {
      const res = await fetchAuthLogout()
      if (res?.code === ResponseCode.SUCCESS) {
        phoneCookie.value = undefined
        tokenCookie.value = undefined
        clearAllCookies()
        globalStore.setIsLogin(false)
        ElMessage.success('退出登录成功')
      }
    } catch (error) {
      console.error('登出失败:', error)
      ElMessage.error('登出失败，请重试')
    }
  }

  // 处理关键字输入
  const handleKeywordInput = () => {
    if (!keyword.value) {
      keywordError.value = false
      keywordPlaceholder.value = $t('menu.keywordPlaceholder1')
    } else if (keyword.value.length > 50) {
      keywordError.value = true
      keywordPlaceholder.value = $t('menu.keywordPlaceholder2')
    } else {
      keywordError.value = !/^[a-zA-Z\u4E00-\u9FA5 \(\)（）]+$/.test(keyword.value)
      keywordPlaceholder.value = $t('menu.keywordPlaceholder3')
    }
  }

  // 处理搜索
  const handleSearch = _.debounce(
    () => {
      if (!/^[0-9a-zA-Z\u4E00-\u9FA5 \(\)（）]+$/.test(keyword.value)) {
        keywordError.value = true
        ElMessage.error($t('menu.keyword_error1'))
        return
      } else {
        keywordError.value = false
      }
      if (keyword.value.length > 50) {
        keywordError.value = true
        ElMessage.error($t('menu.keyword_error2'))
        return
      }
      if (keyword.value) {
        let url = 'https://www.jufair.com'
        if (window.location.host.includes('visa-dev.')) url = 'https://vue.jufair.com'
        if (window.location.host.includes('visa.')) url = 'https://www.jufair.com'

        window.open(`${url}/exhibition/?keyword=${keyword.value}`, '_blank')
      }
    },
    500,
    { leading: true }
  )

  // 处理语言切换
  const handleSetLang = () => {
    const uri = new URLSearchParams(location.search)
    const lang = locale.value === 'en' ? 'zh' : 'en'

    setLang(lang)
    uri.set('lang', lang)

    document.location.search = uri.toString()
  }

  // 使用useAsyncData + Promise.all模式获取初始化数据
  const { data: initialData } = await useAsyncData('header-init-data', async () => {
    try {
      // 并行请求头部需要的初始化数据
      const results = await Promise.all([
        // 可以添加获取菜单配置、用户权限等数据
        Promise.resolve({ code: ResponseCode.SUCCESS, data: { menuEnabled: true } })
      ])

      return {
        menuEnabled: results[0]?.code === ResponseCode.SUCCESS
      }
    } catch (error) {
      console.error('初始化头部数据失败:', error)
      return {
        menuEnabled: false
      }
    }
  })

  // 生命周期
  onBeforeMount(() => {
    // console.log('Header beforeMount, client side:', import.meta.client)
  })
  onMounted(() => {
    if (import.meta.client) {
      // URL中有login参数时，弹出登录框
      if (!isLogin.value && route.query.hasOwnProperty('login')) {
        handleLogin()
      }
    }
  })

  // 初始化处理
  if (initialData.value?.menuEnabled) {
  }

  // 为了兼容模板中的引用
  const lang_t = $t
  const routeRoute = route
</script>

<style lang="less" module>
  .header-container {
    // background: #fff;

    .top {
      height: 36px;
      display: flex;
      align-items: center;
      font-size: 14px;
      background: #f5f5f5;
      border-bottom: 1px solid #eee;

      .other-link {
        display: flex;
        justify-content: flex-end;
        width: @client-width;
        margin: 0 auto;

        ul {
          display: flex;
          align-items: center;
          flex-direction: row;
          margin-bottom: 0;

          li {
            margin: 0 34px 0 0;
            cursor: pointer;

            a {
              display: flex;
              align-items: center;
              height: 17px;
            }

            &:last-child {
              margin: 0;
            }

            :global {
              [class^='el-icon-'] {
                margin-right: 4px;
                height: 16px;
              }
            }
          }

          .red a {
            color: @app-color;
          }

          .logout {
            color: #666;
            cursor: pointer;
          }
        }
      }
    }

    .menu {
      width: @client-width;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 14px 0;

      .list {
        display: flex;

        ul {
          display: flex;
          align-items: center;
          flex-direction: row;
          margin-bottom: 0;

          li {
            margin: 0 44px 0 0;
            font-size: 18px;

            a {
              color: #333;
              font-weight: bold;
            }

            &:hover {
              a {
                color: @app-color;
              }
            }
          }

          .active a {
            color: @app-color;
          }
        }
      }

      .search-container {
        position: relative;
        width: 260px;

        .search-input {
          :global {
            .el-input__wrapper {
              width: 100%;
              border: 1px solid #333;
              background: #f6f6f6;
              box-shadow: unset;

              &:hover {
                box-shadow: none;
              }
            }

            .el-input__wrapper.is-fouces {
              box-shadow: none;
            }

            .el-input__inner {
              width: 260px;
              height: 36px;
              line-height: 36px;
              background: #f6f6f6;

              &::placeholder {
                color: #666;
              }
            }
          }

          &__error {
            :global {
              .el-input__inner {
                //border: 1px solid #f00;
                //color: #f00;
                width: 260px;
                background: #f6f6f6;

                &::placeholder {
                  color: #f00;
                }
              }
            }
          }
        }

        .search-btn {
          position: absolute;
          right: 1px;
          top: 1px;
          background: #f6f6f6;
          border: none;
          font-size: 15px;
          height: 38px;
        }
      }
    }

    .header-lang {
      margin-left: 50px;
      cursor: pointer;
    }
  }
</style>
